/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CourtDayParam } from './CourtDayParam';
import {
    CourtDayParamFromJSON,
    CourtDayParamFromJSONTyped,
    CourtDayParamToJSON,
    CourtDayParamToJSONTyped,
} from './CourtDayParam';

/**
 * 
 * @export
 * @interface UpdateCourtRequest
 */
export interface UpdateCourtRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCourtRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCourtRequest
     */
    shortCode: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCourtRequest
     */
    fileNumberPrefix: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCourtRequest
     */
    zipCode: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCourtRequest
     */
    street: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCourtRequest
     */
    houseNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCourtRequest
     */
    city: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCourtRequest
     */
    country: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdateCourtRequest
     */
    districts: Array<number>;
    /**
     * 
     * @type {Array<CourtDayParam>}
     * @memberof UpdateCourtRequest
     */
    courtDays: Array<CourtDayParam>;
}

/**
 * Check if a given object implements the UpdateCourtRequest interface.
 */
export function instanceOfUpdateCourtRequest(value: object): value is UpdateCourtRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('shortCode' in value) || value['shortCode'] === undefined) return false;
    if (!('fileNumberPrefix' in value) || value['fileNumberPrefix'] === undefined) return false;
    if (!('zipCode' in value) || value['zipCode'] === undefined) return false;
    if (!('street' in value) || value['street'] === undefined) return false;
    if (!('houseNumber' in value) || value['houseNumber'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('districts' in value) || value['districts'] === undefined) return false;
    if (!('courtDays' in value) || value['courtDays'] === undefined) return false;
    return true;
}

export function UpdateCourtRequestFromJSON(json: any): UpdateCourtRequest {
    return UpdateCourtRequestFromJSONTyped(json, false);
}

export function UpdateCourtRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCourtRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'shortCode': json['shortCode'],
        'fileNumberPrefix': json['fileNumberPrefix'],
        'zipCode': json['zipCode'],
        'street': json['street'],
        'houseNumber': json['houseNumber'],
        'city': json['city'],
        'country': json['country'],
        'districts': json['districts'],
        'courtDays': ((json['courtDays'] as Array<any>).map(CourtDayParamFromJSON)),
    };
}

export function UpdateCourtRequestToJSON(json: any): UpdateCourtRequest {
    return UpdateCourtRequestToJSONTyped(json, false);
}

export function UpdateCourtRequestToJSONTyped(value?: UpdateCourtRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'shortCode': value['shortCode'],
        'fileNumberPrefix': value['fileNumberPrefix'],
        'zipCode': value['zipCode'],
        'street': value['street'],
        'houseNumber': value['houseNumber'],
        'city': value['city'],
        'country': value['country'],
        'districts': value['districts'],
        'courtDays': ((value['courtDays'] as Array<any>).map(CourtDayParamToJSON)),
    };
}

